import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import DateColumn from './table/DateColumn'
import SelectColumn from './table/SelectColumn'

class Festivi extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true)
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('idazi').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('dex').withType('text'),
      new DateColumn('data'),
      new SelectColumn('ricorrenza', Mapper.select.ricorrenza()).withOptions([{ value: 0, label: 'Evento unico' }, { value: 1, label: 'Ogni giorno' }, { value: 2, label: 'Ogni settimana' }, { value: 3, label: 'Ogni mese' }, { value: 4, label: 'Ogni anno' }]).withType('number')
    ]
  }

  validator () {
    return {
      data: { required: true },
      dex: { required: true, type: 'string', trigger: 'change' },
      ricorrenza: { required: true, type: 'integer', trigger: 'change' }
    }
  }
}

export default new Festivi()
